/* Industrialsafety-UK smart stock search - core (index, parsing, matching). 2-10-2026 */
(function () {
  'use strict';
  var KEY = 'isu-sidx-v1', TTL = 6 * 3600 * 1000;

  var MATS = [
    { k: 'albronze', n: 'Aluminium Bronze', re: /alumin(?:i)?um bronze|\bca104\b/, d: 7.58, c: '#b98a45' },
    { k: 'stainless', n: 'Stainless Steel', re: /stainl?e?s+|\bs\/?s\b/, d: 7.93, c: '#9aa4af' },
    { k: 'silver', n: 'Silver Steel', re: /silver steel/, d: 7.85, c: '#bfc4c9' },
    { k: 'mild', n: 'Mild Steel', re: /mild steel|\bm\/s\b|bright steel|\ben1a\b|\ben3b?\b|\bs275\b|\bs355\b/, d: 7.85, c: '#6b7280' },
    { k: 'aluminium', n: 'Aluminium', re: /alum[a-z]{0,4}um|alumin|\bali\b|\balu\b|\balum\b/, d: 2.71, c: '#a3adb8' },
    { k: 'copper', n: 'Copper', re: /\bcop+er\b|\bc10[16]\b/, d: 8.94, c: '#bf6040' },
    { k: 'brass', n: 'Brass', re: /\bbras+\b|\bcz1\d\d\b/, d: 8.5, c: '#c9a227' },
    { k: 'bronze', n: 'Bronze', re: /\bbronze?\b|\bpb10[24]\b|\bpb1\b|\blg2\b/, d: 8.86, c: '#a97b3f' },
    { k: 'nylon', n: 'Nylon', re: /nylon|\bpa6\b/, d: 1.14, c: '#d9d4c3' },
    { k: 'acetal', n: 'Acetal', re: /acetal|\bpom\b|delrin/, d: 1.41, c: '#e8e6e1' },
    { k: 'ptfe', n: 'PTFE', re: /\bptfe\b|teflon/, d: 2.2, c: '#eeeeee' },
    { k: 'hdpe', n: 'HDPE', re: /\bhdpe\b|polyethylene|\buhmw/, d: 0.95, c: '#e6e9ec' },
    { k: 'pvc', n: 'PVC', re: /\bpvc\b/, d: 1.4, c: '#8f9399' },
    { k: 'acrylic', n: 'Acrylic', re: /acrylic|perspex|\bpmma\b/, d: 1.19, c: '#cfe3ee' },
    { k: 'polycarb', n: 'Polycarbonate', re: /polycarbonate/, d: 1.2, c: '#d6e6ee' },
    { k: 'pp', n: 'Polypropylene', re: /polypropylene/, d: 0.91, c: '#ebe7dc' }
  ];
  var PROFS = [
    { k: 'box', n: 'Box Section', re: /box section|\bbox\b|\brhs\b|\bshs\b|square tube|rectangular tube/ },
    { k: 'tube', n: 'Tube', re: /\btubes?\b|\bpipes?\b|\btubing\b/ },
    { k: 'angle', n: 'Angle', re: /\bangles?\b/ },
    { k: 'channel', n: 'Channel', re: /channel/ },
    { k: 'tee', n: 'T Section', re: /\btee\b|\bt[ -]?sections?\b/ },
    { k: 'hex', n: 'Hexagon Bar', re: /\bhex(?:agon)?\b/ },
    { k: 'flat', n: 'Flat Bar', re: /\bflats?\b|\bstrips?\b/ },
    { k: 'square', n: 'Square Bar', re: /\bsquare\b/ },
    { k: 'round', n: 'Round Bar', re: /\bround\b|\brods?\b|diameter bar/ },
    { k: 'sheet', n: 'Sheet & Plate', re: /\bsheets?\b|\bplates?\b|tread ?plate|treadbrite/ },
    { k: 'wire', n: 'Wire', re: /\bwire\b/ }
  ];
  var GRADE = /\b(6082(?:[ -]?t6)?|6063(?:[ -]?t6)?|6061|5083|5754|5052|5251|1050a?|3003|2011|7075|304l?|316l?|303|430|c101|c106|cz1\d\d|pb10[24]|pb1|ca104|en1a|en3b?|en8|en24|s275|s355)\b/;
  var GRADE_MAT = { c1: 'copper', cz: 'brass', pb: 'bronze', ca: 'albronze', en: 'mild', s2: 'mild', s3: 'mild', '30': 'stainless', '31': 'stainless', '43': 'stainless' };
  var LINEAR = { flat: 1, round: 1, square: 1, hex: 1, tube: 1, box: 1, angle: 1, channel: 1, tee: 1 };

  function find(list, s) { for (var i = 0; i < list.length; i++) if (list[i].re.test(s)) return list[i]; return null; }
  function gradeMat(g) {
    if (!g) return null;
    if (/^(6|5|1|3|2|7)\d{3}/.test(g)) return 'aluminium';
    return GRADE_MAT[g.slice(0, 2)] || null;
  }
  function mmNums(s) {
    var out = [], m, re = /(\d+(?:\.\d+)?)\s*mm(?![a-z])/g;
    while ((m = re.exec(s)) && out.length < 3) out.push(parseFloat(m[1]));
    return out;
  }
  function headPart(t) { return t.split(/,| - | – | — |\(/)[0]; }

  function prep(r) {
    // r = [id, handle, title, type, sizeTag, priceCents, varies, variantId, available, cutLen, linear, variantsCount]
    var title = r[2], low = (title + ' ' + r[3]).toLowerCase(), tl = (r[3] + ' ' + title).toLowerCase();
    var mat = find(MATS, (r[3] || '').toLowerCase()) || find(MATS, low);
    var prof = find(PROFS, (r[3] || '').toLowerCase()) || find(PROFS, low);
    var gm = low.match(GRADE), grade = gm ? gm[1].toUpperCase().replace(/[ -]?T6$/, ' T6') : '';
    var dims = r[4] ? mmNums(r[4].split('(')[0]) : [];
    if (!dims.length) dims = mmNums(headPart(title));
    var sorted = dims.slice().sort(function (a, b) { return b - a; });
    var kg = 0, km = title.match(/(\d+(?:\.\d+)?)\s*kg\s*\/\s*m/i);
    if (km) kg = parseFloat(km[1]);
    else if (mat && prof && LINEAR[prof.k] && dims.length) kg = area(prof.k, dims) * mat.d / 1000;
    var fin = low.match(/brushed polished|mirror polished|dull polished|bright polished|satin polished|polished|anodised|powder coated|galvani[sz]ed|black annealed|bright drawn|hot rolled/);
    var name = (mat && prof) ? [grade && !/^EN|^S[23]/.test(grade) ? grade : '', mat.n, prof.n].join(' ').trim() : headPart(title).slice(0, 70).trim();
    if (fin && mat && prof) name += ' \u00b7 ' + fin[0].replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    return {
      id: r[0], h: r[1], t: title, type: r[3], name: name, mat: mat, prof: prof, grade: grade,
      dims: dims, sd: sorted, kg: kg, price: r[5], varies: !!r[6], vid: r[7], av: !!r[8], cut: r[9], lin: !!r[10], vc: r[11] || 1,
      txt: (tl + ' ' + (r[4] || '')).toLowerCase()
    };
  }
  function area(p, d) {
    var a = d[0], b = d[1], t = d[2];
    switch (p) {
      case 'flat': return d.length > 1 ? a * b : 0;
      case 'round': return Math.PI * a * a / 4;
      case 'square': return a * (d.length > 1 && b > a * 0.9 ? b : a);
      case 'hex': return 0.866 * a * a;
      case 'tube': return d.length > 1 ? Math.PI * (a - b) * b : 0;
      case 'box': return d.length > 2 ? 2 * t * (a + b - 2 * t) : (d.length > 1 ? 4 * b * (a - b) : 0);
      case 'angle': case 'tee': return d.length > 2 ? t * (a + b - t) : (d.length > 1 ? b * (2 * a - b) : 0);
      case 'channel': return d.length > 2 ? t * (a + 2 * b - 2 * t) : 0;
    }
    return 0;
  }

  /* ---------- index loading ---------- */
  var DATA = null, loading = null;
  function readCache() {
    try { var c = JSON.parse(localStorage.getItem(KEY)); if (c && Date.now() - c.t < TTL && c.r && c.r.length) return c.r; } catch (e) {}
    return null;
  }
  function writeCache(rows) { try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), r: rows })); } catch (e) {} }
  function page(n) {
    return fetch('/collections/all?view=isu-index&page=' + n, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('index ' + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }
  function load() {
    if (DATA) return Promise.resolve(DATA);
    if (loading) return loading;
    var cached = readCache();
    if (cached) { DATA = cached.map(prep); return Promise.resolve(DATA); }
    loading = page(1).then(function (first) {
      var rows = first.r.slice(), n = first.n, pages = [];
      for (var i = 2; i <= n; i++) pages.push(i);
      function next() {
        if (!pages.length) return Promise.resolve();
        var p = pages.shift();
        return page(p).then(function (j) { rows = rows.concat(j.r); return next(); });
      }
      return Promise.all([next(), next(), next(), next()]).then(function () {
        var seen = {}, uniq = rows.filter(function (r) { if (seen[r[0]]) return false; seen[r[0]] = 1; return true; });
        writeCache(uniq);
        DATA = uniq.map(prep);
        return DATA;
      });
    });
    loading.catch(function () { loading = null; });
    return loading;
  }

  /* ---------- query parsing ---------- */
  function num(s) {
    s = s.trim();
    var m;
    if ((m = s.match(/^(\d+)[ .\-](\d+)\/(\d+)$/))) return { v: +m[1] + m[2] / m[3], frac: 1 };
    if ((m = s.match(/^(\d+)\/(\d+)$/))) return { v: m[1] / m[2], frac: 1 };
    if ((m = s.match(/^(\d+(?:\.\d+)?)$/))) return { v: parseFloat(m[1]), frac: 0 };
    return null;
  }
  function parse(q) {
    var s = ' ' + String(q || '').toLowerCase().replace(/×/g, 'x').replace(/[″”]/g, '"').replace(/\s+/g, ' ') + ' ';
    var out = { raw: q, mat: null, prof: null, grade: '', dims: [], inch: false, words: [] };
    var g = s.match(GRADE);
    if (g) { out.grade = g[1].toUpperCase().replace(/[ -]?T6$/, ' T6'); s = s.replace(g[0], ' '); }
    var m = find(MATS, s);
    if (m) { out.mat = m; s = s.replace(m.re, ' '); }
    var p = find(PROFS, s), tread = false;
    if (p) { out.prof = p; tread = /tread/.test(s.match(p.re)[0]); s = s.replace(p.re, ' '); }
    s = s.replace(/\bbars?\b|\bsections?\b|\bprofiles?\b|\bmetal\b|\bstock\b|\bmill finish\b/g, ' ');
    if (!out.mat && out.grade) { var gk = gradeMat(out.grade.toLowerCase()); if (gk) out.mat = MATS.filter(function (x) { return x.k === gk; })[0]; }
    // sizes
    if (/"|\binch(?:es)?\b|\bin\b/.test(s)) out.inch = true;
    var mmFlag = /\d\s*mm\b/.test(s);
    var sz = s.replace(/\binch(?:es)?\b|\bin\b|"|mm\b/g, ' ').replace(/(\d)\s*x\s*(\d)/g, '$1 x $2').replace(/(\d)x\b/g, '$1 x').replace(/\bx(\d)/g, 'x $1');
    var words = [];
    var re = /(\d+(?:[ .\-]\d+\/\d+|\/\d+|\.\d+)?)/g, mm, parts = [];
    var rest = sz.replace(re, function (t) { parts.push(t); return ' '; });
    var frac = false, vals = [];
    parts.forEach(function (t) { var n = num(t); if (n) { vals.push(n.v); if (n.frac) frac = true; } });
    if (frac && !mmFlag) out.inch = true;
    if (mmFlag) out.inch = false;
    out.dims = vals.slice(0, 3).map(function (v) { return out.inch ? v * 25.4 : v; });
    rest.split(/[^a-z0-9]+/).forEach(function (w) { if (w && w !== 'x' && w !== 'by' && w.length > 1) words.push(w); });
    if (tread) words.push('tread');
    out.words = words;
    out.empty = !out.mat && !out.prof && !out.grade && !out.dims.length && !words.length;
    return out;
  }
  function label(pq) {
    var a = [];
    if (pq.grade) a.push(pq.grade);
    if (pq.mat) a.push(pq.mat.n.toLowerCase());
    if (pq.prof) a.push(pq.prof.n.toLowerCase());
    if (pq.dims.length) a.push(pq.dims.map(function (d) { return +d.toFixed(2); }).join(' x ') + 'mm');
    return a.concat(pq.words).join(' ');
  }

  /* ---------- matching ---------- */
  function tolOf(q, pct) { return pct === 'in' ? Math.max(0.4, q * 0.025) : pct ? q * pct : Math.max(0.8, q * 0.04); }
  function cmp(p, Q, pct) {
    // returns -1 (no) or score >=0 (lower is closer); exact flag via .ex
    if (!p.sd.length) return null;
    var P = p.sd, isSheet = p.prof && p.prof.k === 'sheet';
    var sq = Q.slice().sort(function (a, b) { return b - a; }), pairs = [];
    if (sq.length === 1) pairs = [[isSheet ? P[P.length - 1] : P[0], sq[0]]];
    else { if (P.length < sq.length) return null; for (var i = 0; i < sq.length; i++) pairs.push([P[i], sq[i]]); }
    var ex = true, score = 0;
    for (var j = 0; j < pairs.length; j++) {
      var d = Math.abs(pairs[j][0] - pairs[j][1]), q = pairs[j][1];
      if (d > tolOf(q, pct)) ex = false;
      score += d / q;
    }
    return { ex: ex, score: score, near: pairs.every(function (x) { return Math.abs(x[0] - x[1]) / x[1] <= 0.3; }) };
  }
  function lev1(a, b) {
    if (Math.abs(a.length - b.length) > 1) return false;
    var i = 0, j = 0, e = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++e > 1) return false;
      if (a.length > b.length) i++; else if (b.length > a.length) j++; else { i++; j++; }
    }
    return e + (a.length - i) + (b.length - j) <= 1;
  }
  function wordHit(p, w) {
    if (p.txt.indexOf(w) > -1) return true;
    if (w.length < 5) return false;
    var ws = p._w || (p._w = p.txt.split(/[^a-z0-9]+/));
    for (var i = 0; i < ws.length; i++) if (ws[i].length > 3 && lev1(ws[i], w)) return true;
    return false;
  }
  function base(data, pq, opt) {
    opt = opt || {};
    return data.filter(function (p) {
      if (pq.mat && !opt.anyMat && (!p.mat || p.mat.k !== pq.mat.k)) return false;
      if (pq.prof && (!p.prof || p.prof.k !== pq.prof.k)) return false;
      if (pq.grade && !opt.anyMat && p.grade.replace(' T6', '') !== pq.grade.replace(' T6', '') && p.txt.indexOf(pq.grade.toLowerCase()) < 0) return false;
      for (var i = 0; i < pq.words.length; i++) if (!wordHit(p, pq.words[i])) return false;
      return true;
    });
  }
  function bySize(a, b) { var x = a.sd.length ? 0 : 1, y = b.sd.length ? 0 : 1; return (x - y) || ((a.sd[0] || 0) - (b.sd[0] || 0)) || ((a.sd[1] || 0) - (b.sd[1] || 0)) || ((a.sd[2] || 0) - (b.sd[2] || 0)); }
  function search(data, pq) {
    var res = { exact: [], near: [], other: [], all: [] };
    if (!data || pq.empty) return res;
    var set = base(data, pq);
    if (pq.dims.length) {
      set.forEach(function (p) {
        var c = cmp(p, pq.dims, pq.inch ? 'in' : 0);
        if (!c) return;
        p._s = c.score;
        if (c.ex) res.exact.push(p); else if (c.near) res.near.push(p);
      });
      var byS = function (a, b) { return a._s - b._s; };
      res.exact.sort(byS); res.near.sort(byS);
      if (pq.mat) {
        base(data, pq, { anyMat: true }).forEach(function (p) {
          if (p.mat && p.mat.k === pq.mat.k) return;
          var c = cmp(p, pq.dims, pq.inch ? 'in' : 0);
          if (c && c.ex) { p._s = c.score; res.other.push(p); }
        });
        res.other.sort(byS);
      }
      res.all = res.exact.concat(res.near);
    } else {
      res.all = set.sort(bySize);
      res.exact = res.all;
    }
    return res;
  }

  /* ---------- formatting ---------- */
  function money(c) { return '£' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function trim(n) { return String(+n.toFixed(2)); }
  function inch(mm) {
    var v = mm / 25.4;
    if (Math.abs(mm - Math.round(mm)) > 1e-6) {
      var w = Math.floor(v + 1e-9), f = v - w;
      for (var den = 2; den <= 32; den *= 2) {
        var nn = Math.round(f * den);
        if (Math.abs((w + nn / den) * 25.4 - mm) <= 0.06) {
          if (nn === den) return (w + 1) + '"';
          if (!nn) return w + '"';
          return (w ? w + ' ' : '') + nn + '/' + den + '"';
        }
      }
    }
    return (+v.toFixed(2)) + '"';
  }
  function size(p, unit) {
    if (!p.dims.length) return '';
    return unit === 'in' ? p.dims.map(inch).join(' × ') : p.dims.map(trim).join(' × ') + ' mm';
  }
  function altSize(p, unit) { return size(p, unit === 'in' ? 'mm' : 'in'); }
  function unit() { try { return localStorage.getItem('isu-unit') === 'in' ? 'in' : 'mm'; } catch (e) { return 'mm'; } }
  function setUnit(u) { try { localStorage.setItem('isu-unit', u); } catch (e) {} }
  function addToCart(p, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: p.vid, quantity: qty > 1 && p.lin ? qty : 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.isu-ic--cart').forEach(function (a) {
          var b = a.querySelector('.isu-ic__n');
          if (!b) { b = document.createElement('b'); b.className = 'isu-ic__n'; a.appendChild(b); }
          b.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('isu:cart', { detail: cart }));
        return cart;
      });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  window.ISUS = {
    load: load, parse: parse, label: label, search: search, base: base, cmp: cmp,
    money: money, size: size, altSize: altSize, inch: inch, trim: trim, unit: unit, setUnit: setUnit,
    add: addToCart, esc: esc, bySize: bySize, prep: prep, MATS: MATS, PROFS: PROFS
  };
})();
